// Registers a global custom directive called `v-animate`
const animate = function (el, binding) {

        // Default animation class
        const defaultAnimation = 'flyUp'

        // If needed, could pass this as part of the binding as well?
        const options = { threshold: 0.25 }

         // Add animation block class
        el.classList.add('animation')

        // Initiate the observer
        const observer = new IntersectionObserver(([entry]) => {
            if (entry && entry.isIntersecting) {

                // Either use the value from the directive (like v-animate="{modifier: someModifier}" or v-animate="someModifier")
                // Or without that, use the default flyUp animation
                const animationModifier = `-${
                    (binding.hasOwnProperty('value') && binding.value.hasOwnProperty('modifier'))
                        ? binding.value.modifier
                        : binding.value
                        ?? defaultAnimation
                }`

                entry.target.classList.add(animationModifier)

                // Unobserve now that work is done.
                observer.unobserve(entry.target)
            }
        }, options);

        // Observe the el
        observer.observe(el);
    }

    export default animate